module.exports = __webpack_public_path__ + "8cb35ea8be7d77f4c1da9a03697d2c81.jpg";